
import { Options, Vue } from "vue-class-component";
import { PropType } from "vue";
import IPayment from "@/entities/IPayment";

@Options({
  props: {
    payment: {
      type: Object as PropType<IPayment>,
      required: true,
    },
  },
})
export default class PaymentInfo extends Vue {}
